<template>
  <div class="overflow-auto" v-if="ne" v-loading="isLoading">
    <div class="detail-wraper">
      <div class="leftSideWraper">
        <div class="offSetChart">
          <div class="text-right">
            <!-- <p class="y1AxisLabel">
              200 -
              <span class="ml--1px">-</span>
              <span class="ml--1px">-</span>
            </p>-->
            <p class="y1AxisLabel">160 -</p>
            <p class="y1AxisLabel">140 -</p>
            <p class="y1AxisLabel">120 -</p>
            <p class="y1AxisLabel">100 -</p>
            <p class="y1AxisLabel">80 -</p>
            <p class="y1AxisLabel">60 -</p>
            <p class="y1AxisLabel">40 -</p>
            <!-- <p class="y1AxisLabel">
              0 -
              <span class="ml--1px">-</span>
              <span class="ml--1px">-</span>
            </p>-->
          </div>
        </div>
        <div class="bg-E0E0E0 pt-3 label-sign">
          <div class="other-sign-item-stat mb-2 pt-2">
            <p class="fs-12 mb-0 fw-500">Giờ, phút</p>
            <p class="fs-12 mb-0 fw-500">Ngày, tháng, năm</p>
          </div>
          <div class="other-sign-item-stat">
            <p class="fs-12 mb-0 fw-500">Huyết áp</p>
            <p class="fs-10 mb-0 fw-500">(mmHg)</p>
          </div>
          <div class="other-sign-item-stat">
            <p class="fs-12 mb-0 fw-500">Nhịp thở</p>
            <p class="fs-10 mb-0 fw-500">(lần/phút)</p>
          </div>
          <div class="other-sign-item-stat">
            <p class="fs-12 mb-0 fw-500">Cân nặng</p>
            <p class="fs-10 mb-0 fw-500">(kg)</p>
          </div>
        </div>
      </div>
      <div class="middleSideWraper">
        <div class="relative" ref="chartVital">
          <LineChart
            id="chartNe"
            :style="chart.css"
            :chart-data="chart.data"
            :options="chart.options"
            :class="'chartAreaWrapper'"
          ></LineChart>
          <div class="absolute top-0 left-0 w-full pointer-events-none" style="z-index: -1;">
            <LineChart
              id="chartNeHidden"
              :style="{width: '100%', height: '400px'}"
              :chart-data="{labels: [], padding: 0, datasets: []}"
              :options="chartHidden.options"
              :class="'chartAreaWrapper'"
            ></LineChart>
          </div>
          <div
            class="absolute top-0 left-0 opacity-0 h-0 invisible overflow-hidden pointer-events-none"
            style="z-index: -1;"
          >
            <LineChart
              id="chartNeHiddenData"
              :style="chartHiddenData.css"
              :chart-data="chart.data"
              :options="chart.options"
              :settings="chart"
              :isDownload="isDownload"
              @setImageChart="setImageChart"
              :class="'chartAreaWrapper'"
            ></LineChart>
          </div>
        </div>
        <div class="other-sign bg-CDDEF9" v-if="signs && signs.length">
          <div class="flex">
            <div class="spacing-other-sign"></div>
            <div
              v-for="(s, index) in signs"
              class="other-sign-item bg-CDDEF9"
              :key="`${s.id || index}_sign`"
            >
              <div class="mt--5px">|</div>
              <div class="other-sign-item-stat mb-2 pt-2">
                <el-tooltip placement="right" v-if="s.last_updated_by">
                  <div slot="content">
                    <p class="fs-12 fw-500 text-white">{{ s.last_updated_by.name }}</p>
                    <p class="fs-12 fw-700 text-white mb-1">
                      Ngày:
                      {{
                      s.updated_at &&
                      moment(s.updated_at).format("DD/MM/YYYY")
                      }}
                    </p>
                    <p class="fs-12 fw-700 text-white mb-0">
                      Giờ:
                      {{ s.updated_at && moment(s.updated_at).format("HH:mm") }}
                    </p>
                  </div>
                  <div class="changed-sign-flag">
                    <svg
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      class="cursor-pointer"
                    >
                      <path
                        d="M6.00023 7.99989C5.90134 7.99989 5.80467 8.02922 5.72244 8.08416C5.64022 8.1391 5.57613 8.21719 5.53829 8.30855C5.50044 8.39991 5.49054 8.50045 5.50984 8.59744C5.52913 8.69443 5.57675 8.78352 5.64667 8.85345C5.7166 8.92337 5.80569 8.97099 5.90268 8.99028C5.99967 9.00958 6.10021 8.99968 6.19157 8.96183C6.28293 8.92399 6.36102 8.8599 6.41596 8.77768C6.4709 8.69545 6.50023 8.59878 6.50023 8.49989C6.50023 8.36728 6.44755 8.24011 6.35378 8.14634C6.26001 8.05257 6.13284 7.99989 6.00023 7.99989ZM11.3352 8.73489L7.31023 1.73489C7.18013 1.50165 6.99012 1.30737 6.75982 1.17213C6.52953 1.03688 6.2673 0.965576 6.00023 0.965576C5.73316 0.965576 5.47093 1.03688 5.24063 1.17213C5.01034 1.30737 4.82032 1.50165 4.69023 1.73489L0.690228 8.73489C0.555626 8.9619 0.483299 9.2204 0.48055 9.4843C0.477801 9.7482 0.544727 10.0082 0.674571 10.2379C0.804415 10.4677 0.99258 10.6591 1.22007 10.7929C1.44756 10.9267 1.70632 10.9981 1.97023 10.9999H10.0302C10.2963 11.0025 10.5582 10.9343 10.7892 10.8023C11.0202 10.6704 11.2119 10.4793 11.3447 10.2488C11.4775 10.0183 11.5466 9.7566 11.545 9.49056C11.5433 9.22453 11.4709 8.96372 11.3352 8.73489ZM10.4702 9.73489C10.4264 9.81287 10.3625 9.87766 10.2851 9.92251C10.2077 9.96736 10.1197 9.99063 10.0302 9.98989H1.97023C1.88078 9.99063 1.79278 9.96736 1.71539 9.92251C1.638 9.87766 1.57405 9.81287 1.53023 9.73489C1.48634 9.65888 1.46324 9.57266 1.46324 9.48489C1.46324 9.39712 1.48634 9.3109 1.53023 9.23489L5.53023 2.23489C5.57219 2.15299 5.63593 2.08426 5.71445 2.03626C5.79297 1.98827 5.8832 1.96287 5.97523 1.96287C6.06725 1.96287 6.15749 1.98827 6.23601 2.03626C6.31452 2.08426 6.37827 2.15299 6.42023 2.23489L10.4452 9.23489C10.4948 9.30981 10.5233 9.39671 10.5277 9.48646C10.5321 9.57621 10.5123 9.66548 10.4702 9.74489V9.73489ZM6.00023 3.99989C5.86762 3.99989 5.74044 4.05257 5.64667 4.14634C5.55291 4.24011 5.50023 4.36728 5.50023 4.49989V6.49989C5.50023 6.6325 5.55291 6.75968 5.64667 6.85345C5.74044 6.94721 5.86762 6.99989 6.00023 6.99989C6.13284 6.99989 6.26001 6.94721 6.35378 6.85345C6.44755 6.75968 6.50023 6.6325 6.50023 6.49989V4.49989C6.50023 4.36728 6.44755 4.24011 6.35378 4.14634C6.26001 4.05257 6.13284 3.99989 6.00023 3.99989Z"
                        fill="#E98753"
                      />
                    </svg>
                  </div>
                </el-tooltip>
                <p
                  class="fs-12 mb-0 fw-500"
                >{{ s.record_time && moment(s.record_time).format("HH:mm") }}</p>
                <p class="fs-12 mb-0 fw-500">
                  {{
                  s.record_time && moment(s.record_time).format("DD/MM/YYYY")
                  }}
                </p>
              </div>
              <div class="other-sign-item-stat">
                <p class="fs-12 mb-0 fw-500">
                  {{
                  s.systolic_pressure &&
                  s.diastolic_pressure &&
                  s.systolic_pressure + "/" + s.diastolic_pressure
                  }}
                </p>
              </div>
              <div class="other-sign-item-stat">
                <p class="fs-12 mb-0 fw-500">{{ s.breath }}</p>
              </div>
              <div class="other-sign-item-stat">
                <p class="fs-12 mb-0 fw-500">{{ s.weight }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="rightSideWraper">
        <div class="offSetChartRight">
          <div class="text-left">
            <!-- <p class="y2AxisLabel">
              -
              <span class="ml--1px">-</span>
              <span class="ml--1px">-</span> 43
            </p>
            <p class="y2AxisLabel">
              -
              <span class="ml--1px">-</span>
              <span class="ml--1px">-</span> 42
            </p>-->
            <p class="y2AxisLabel">- 41</p>
            <p class="y2AxisLabel">- 40</p>
            <p class="y2AxisLabel">- 39</p>
            <p class="y2AxisLabel">- 38</p>
            <p class="y2AxisLabel">- 37</p>
            <p class="y2AxisLabel">- 36</p>
            <p class="y2AxisLabel">- 35</p>
          </div>
        </div>
        <div class="pt-5 print:hidden">
          <div class="ml-1 cursor-pointer relative button-add" @click="openNewVitalSign()">
            <div
              class="hidden absolute z-10 -top-10 -left-32 bg-black text-white whitespace-nowrap p-2 rounded-lg w-fit"
            >Thêm chỉ số vào phiếu</div>
            <svg
              width="30"
              height="30"
              viewBox="0 0 30 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.25 16.25H13.75V18.75C13.75 19.0815 13.8817 19.3995 14.1161 19.6339C14.3505 19.8683 14.6685 20 15 20C15.3315 20 15.6495 19.8683 15.8839 19.6339C16.1183 19.3995 16.25 19.0815 16.25 18.75V16.25H18.75C19.0815 16.25 19.3995 16.1183 19.6339 15.8839C19.8683 15.6495 20 15.3315 20 15C20 14.6685 19.8683 14.3505 19.6339 14.1161C19.3995 13.8817 19.0815 13.75 18.75 13.75H16.25V11.25C16.25 10.9185 16.1183 10.6005 15.8839 10.3661C15.6495 10.1317 15.3315 10 15 10C14.6685 10 14.3505 10.1317 14.1161 10.3661C13.8817 10.6005 13.75 10.9185 13.75 11.25V13.75H11.25C10.9185 13.75 10.6005 13.8817 10.3661 14.1161C10.1317 14.3505 10 14.6685 10 15C10 15.3315 10.1317 15.6495 10.3661 15.8839C10.6005 16.1183 10.9185 16.25 11.25 16.25ZM26.25 2.5H3.75C3.41848 2.5 3.10054 2.6317 2.86612 2.86612C2.6317 3.10054 2.5 3.41848 2.5 3.75V26.25C2.5 26.5815 2.6317 26.8995 2.86612 27.1339C3.10054 27.3683 3.41848 27.5 3.75 27.5H26.25C26.5815 27.5 26.8995 27.3683 27.1339 27.1339C27.3683 26.8995 27.5 26.5815 27.5 26.25V3.75C27.5 3.41848 27.3683 3.10054 27.1339 2.86612C26.8995 2.6317 26.5815 2.5 26.25 2.5ZM25 25H5V5H25V25Z"
                fill="#20419B"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>

    <TempPhieuChucNangSong
      :imageChart="imageChart"
      :signData="viewingData && viewingData.vitalsigns"
      @setIsLoading="setIsLoading"
    />
  </div>
</template>

<script>
import moment from 'moment'
import { Chart } from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'

import LineChart from '../../../../utils/LineChart'
import TempPhieuChucNangSong from '../../../../templates/PhieuChucNangSong'

Chart.plugins.register(ChartDataLabels)

export default {
  name: 'EmrVitalsignDetail',
  components: { LineChart, TempPhieuChucNangSong },
  props: ['viewingData', 'isDownload'],
  data () {
    return {
      isLoading: false,
      chart: {},
      chartHidden: {},
      chartHiddenData: {},
      ne: false,
      signs: [],
      moment,
      otherSignWidth: 0,
      imageChart: {}
    }
  },
  watch: {
    viewingData (data) {
      this.ne = false
      this.handleData(data)
    },
    ne () {
      setTimeout(() => {
        const chartEl = document.getElementById('chartNe')
        const chartWidth = chartEl.clientWidth
        this.otherSignWidth = chartWidth
        console.log()
      }, 200)
    },
    isDownload (status) {
      // this.setIsLoading(status)
    }
  },
  mounted () {
    this.handleData(this.viewingData)
  },
  methods: {
    handleData (data) {
      const signsRaw = [...(data?.vitalsigns || [])]
      let xLabel = ['']
      let y1Data = [null]
      let y2Data = [null]

      this.signs = signsRaw

      signsRaw &&
        signsRaw.forEach(vs => {
          if (vs.record_time) {
            xLabel.push(vs.record_time)
            y1Data.push(vs.bpm || null)
            y2Data.push(vs.temperature || null)
          }
        })
      xLabel.push('')
      this.chart.options = {
        tooltips: {
          enabled: true
        },
        plugins: {
          datalabels: {
            backgroundColor: function (context) {
              return context.dataset.borderColor
            },
            borderRadius: 4,
            color: 'white',
            font: {
              weight: 'bold'
            },
            padding: 4
          }
        },
        bezierCurve: true,
        legend: {
          display: false,
          position: 'top'
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              gridLines: {
                display: false,
                drawBorder: true,
                drawOnChartArea: false,
                color: 'black',
                tickMarkLength: 6
              },
              ticks: {
                padding: 15,
                display: false
              }
            }
          ],
          yAxes: [
            {
              id: 'A',
              type: 'linear',
              position: 'left',
              offset: true,
              ticks: {
                display: false,
                stepSize: 20,
                min: 40,
                max: 160,
                padding: 8
              },
              gridLines: {
                display: true,
                drawBorder: false,
                drawOnChartArea: true,
                color: 'black',
                tickMarkLength: 6
              }
            },
            {
              id: 'B',
              type: 'linear',
              position: 'right',
              offset: true,
              ticks: {
                display: false,
                stepSize: 1,
                min: 35,
                max: 41,
                padding: 8
              },
              gridLines: {
                display: true,
                drawBorder: false,
                drawOnChartArea: true,
                color: 'black',
                tickMarkLength: 6
              }
            }
          ]
        }
      }

      this.chartHidden.options = {
        tooltips: {
          enabled: false
        },
        bezierCurve: true,
        legend: {
          display: false,
          position: 'top'
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              gridLines: {
                display: false,
                drawBorder: true,
                drawOnChartArea: false,
                color: 'black',
                tickMarkLength: 6
              },
              ticks: {
                padding: 15,
                display: false
              }
            }
          ],
          yAxes: [
            {
              id: 'A',
              type: 'linear',
              position: 'left',
              offset: true,
              ticks: {
                display: false,
                stepSize: 20,
                min: 40,
                max: 160,
                padding: 8
              },
              gridLines: {
                display: true,
                drawBorder: false,
                drawOnChartArea: true,
                color: 'black',
                tickMarkLength: 6
              }
            },
            {
              id: 'B',
              type: 'linear',
              position: 'right',
              offset: true,
              ticks: {
                display: false,
                stepSize: 1,
                min: 35,
                max: 41,
                padding: 8
              },
              gridLines: {
                display: true,
                drawBorder: false,
                drawOnChartArea: true,
                color: 'black',
                tickMarkLength: 6
              }
            }
          ]
        }
      }

      this.chart.data = {
        labels: xLabel,
        padding: 5,
        datasets: [
          {
            label: 'Mạch',
            yAxisID: 'A',
            data: y1Data,
            backgroundColor: 'transparent',
            lineTension: 0,
            borderColor: '#DE4848',
            pointStyle: 'circle',
            pointRadius: 4,
            pointHoverRadius: 6,
            pointBackgroundColor: '#DE4848',
            datalabels: {
              align: 'end',
              anchor: 'end'
            }
          },
          {
            label: 'Nhiệt độ',
            yAxisID: 'B',
            data: y2Data,
            backgroundColor: 'transparent',
            lineTension: 0,
            borderColor: '#1A80FD',
            pointStyle: 'circle',
            pointRadius: 4,
            pointHoverRadius: 6,
            pointBackgroundColor: '#1A80FD',
            datalabels: {
              align: 'start',
              anchor: 'start'
            }
          }
        ]
      }

      if (xLabel.length < 7) {
        xLabel.push('')
        xLabel.push('')
        xLabel.push('')
      }

      let varNeShow = xLabel.length <= 10 ? 92 : 90
      let widthShow = (xLabel.length - 1) * varNeShow
      if (widthShow < 400) widthShow = 400

      this.chart.css = {
        width: `${widthShow}px`,
        height: `${400}px`
      }

      let varNeHide = 34.72
      let widthHide = (xLabel.length - 1) * varNeHide
      // if (widthHide < 400) widthHide = 400

      this.chartHiddenData.css = {
        width: `${widthHide}px`,
        height: `${553}px`
      }

      setTimeout(() => {
        this.ne = true
      }, 200)
    },
    openNewVitalSign () {
      this.$emit('showAddSign', this.viewingData)
    },
    setImageChart (data) {
      this.imageChart = data
    },
    setIsLoading (status) {
      this.isLoading = status
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .middleSideWraper {
    overflow-x: auto;
    // max-width: 1000px;
    width: 100%;
    margin-left: -5px;
    z-index: 1;
  }

  .chartWrapper > canvas {
    height: 400px !important;
  }

  .offSetChart {
    height: 400px;
    width: 105px;
    border-right: 1px solid black;
    z-index: 2;
    padding-top: 18px;
  }

  .offSetChartRight {
    height: 400px;
    width: 45px;
    border-left: 1px solid black;
    z-index: 2;
    padding-top: 18px;
  }

  .leftSideWraper {
    width: 105px;
    z-index: 2;
  }

  .other-sign {
    min-width: 400px;
  }

  .other-sign-item {
    flex-shrink: 0;
    width: 90px !important;
    display: block;
    text-align: center;
    position: relative;
  }

  .other-sign-item-stat {
    width: 100%;
    text-align: center;
    height: 45px;
  }

  .detail-wraper {
    display: flex;
    width: 100%;
    overflow-x: auto;
  }

  .bg-CDDEF9 {
    background-color: #cddef9;
  }

  .bg-E0E0E0 {
    background-color: #e0e0e0;
  }

  .label-sign {
    z-index: 1000;
  }

  .y2AxisLabel {
    margin-bottom: 36.1px;
  }

  .y1AxisLabel {
    margin-bottom: 36.1px;
  }

  .spacing-other-sign {
    width: 49.5px;
    border-left: 1px solid black;
    flex-shrink: 0;
  }

  .mt--5px {
    margin-top: -5px;
  }

  .ml--1px {
    margin-left: -1px;
  }

  .border-bottom-black {
    border-bottom: 1px solid black;
  }

  .changed-sign-flag {
    position: absolute;
    right: 10px;
    top: 20px;
  }

  .button-add:hover {
    > div {
      display: block;
    }
  }
}
</style>
